var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{staticStyle:{"padding-top":"128px"},attrs:{"status":"404","title":"404","sub-title":"页面不存在"}})
}
var staticRenderFns = []

export { render, staticRenderFns }